import ConfigManager from '@/config/ConfigManager.js'
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import Account from '@/helper/AccountHelper';
import { MissionModel } from '@/core/Account/model/MissionModel'
export default {
    getMissionCheckin: function (key) {
        const token = Account.getToken();
        let params = {
            app_id: ConfigManager.getAppId(),
            badge_id: key,
        }
        const url = ConfigManager.getApiUrl() + '/profile/me/badges';
        return BzbsApi.connectBzbsGet(url, token, params)
            .pipe(map((res) => {
                var arrMission = [];
                for (var i of res.data) {
                    var objMission = new MissionModel(i);
                    arrMission.push(objMission);
                }
            return arrMission;
        }));
    },
    postMissionCheckin: function () {
        const token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/mission/checkin';
        return BzbsApi.connectBzbsPost(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },
    inviteSms: function(params){
        const token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/user/invite';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    }
}
